module.exports = __webpack_public_path__ + "static/media/giovanni_lo_celso.56cb40b1.jpg";